var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97189 2.28174C9.24969 1.7571 10.6189 1.49137 12.0002 1.49996C13.3815 1.49137 14.7507 1.7571 16.0285 2.28174C17.3063 2.80637 18.4672 3.57947 19.444 4.5562C20.4207 5.53293 21.1938 6.69385 21.7184 7.97165C22.2431 9.24944 22.5088 10.6187 22.5002 12C22.5088 13.3812 22.2431 14.7505 21.7184 16.0283C21.1938 17.3061 20.4207 18.467 19.444 19.4437C18.4672 20.4204 17.3063 21.1935 16.0285 21.7182C14.7507 22.2428 13.3815 22.5085 12.0002 22.5C10.6189 22.5085 9.24969 22.2428 7.97189 21.7182C6.6941 21.1935 5.53317 20.4204 4.55644 19.4437C3.57971 18.467 2.80662 17.3061 2.28198 16.0283C1.75735 14.7505 1.49162 13.3812 1.5002 12C1.49162 10.6187 1.75735 9.24944 2.28198 7.97165C2.80662 6.69385 3.57971 5.53293 4.55644 4.5562C5.53317 3.57947 6.6941 2.80637 7.97189 2.28174ZM7.00007 19.4832C8.48011 20.4721 10.2202 21 12.0002 21C14.385 20.993 16.6701 20.0425 18.3564 18.3562C20.0428 16.6699 20.9932 14.3848 21.0002 12C21.0002 10.2199 20.4724 8.47987 19.4834 6.99983C18.4945 5.51978 17.0889 4.36623 15.4444 3.68504C13.7998 3.00385 11.9902 2.82562 10.2444 3.17289C8.49856 3.52016 6.89491 4.37732 5.63624 5.636C4.37757 6.89467 3.5204 8.49832 3.17313 10.2441C2.82587 11.99 3.0041 13.7996 3.68529 15.4441C4.36647 17.0886 5.52003 18.4943 7.00007 19.4832ZM6.75027 7.9165L7.91679 6.74999L17.2503 16.0835L16.0838 17.25L6.75027 7.9165Z",
    fill: "#A01417"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.69ac3d0956106002dc39bfb25bfcc4ce.svg";
export { ForwardRef as ReactComponent };